// @givmo/app-charity — the charity console's assistant SCOPES: the pages the assistant is on.
//
// ══ THE REGISTRY ═══════════════════════════════════════════════════════════════════════════════
//
// The console's ONE assistant control renders only on a page one of these covers (Jonathan, 2026-11-01
// 13:28: built out page by page, on in production and gaining pages over time). There is no general
// charity assistant: a page joins once its module's audience exists on the backend — its
// instructions and its tools — and then by ONE entry here. The shell, the slot and the dock never
// change for it. Steps: `agent_docs/assistant-panel-package.md` § Adding the assistant to a page.
//
// Today: the Emails editor, where the panel IS the email designer — the `org_email_designer`
// audience and its tools, the email's own conversation (one thread per email: the per-record
// exception to D-EP-40), open by default beside the email.

import type { AssistantScope } from '@givmo/assistant-panel';
import {
  EMAIL_DESIGNER_WIRE_SURFACE,
  FUNDRAISER_EMAIL_DESIGN_PATH,
} from '@givmo/fundraisers-module';

/**
 * The Emails editor: the email designer (EMC-WEB10). The page draws the panel's body itself — its
 * turns wait on the page's own hand edits, and each changes the email the page shows — so the scope
 * declares the audience, the thread and the default, and the page supplies the conversation
 * (`EmailDesignerPage`, through `AssistantPageBody`), stamping the same context (with the organization
 * it is in) on its thread.
 */
export const EMAIL_DESIGNER_SCOPE: AssistantScope = {
  id: 'email-designer',
  pattern: FUNDRAISER_EMAIL_DESIGN_PATH,
  wireSurface: EMAIL_DESIGNER_WIRE_SURFACE,
  context: ({ params }) => ({
    fundraiser_id: params.fundraiserId ?? '',
    email_id: params.emailId ?? '',
  }),
  thread: 'record',
  defaultOpen: true,
  pageBody: true,
};

/** The scopes this build declares: the email editor's, served with the Emails pages (EMC-BE21 retired
 *  its own knob; the backend's campaign email switch decides whether the editor answers at all). */
export function charityAssistantScopes(): readonly AssistantScope[] {
  return [EMAIL_DESIGNER_SCOPE];
}
